import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { CreateFirm } from "@/features/firms/components/create-firm"

/**
 * The step is held in the URL rather than in component state. A screening runs
 * against the registers and takes as long as it takes, so a visitor who
 * refreshes or comes back to the tab must land back on it rather than at the
 * start of the flow.
 */
const searchSchema = z.object({
  q: z.string().optional(),
  closed: z.boolean().optional(),
  screening: z.uuid().optional(),
  manual: z.boolean().optional(),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/firms/create/"
)({
  validateSearch: searchSchema,
  component: CreateFirmPage,
})

function CreateFirmPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <CreateFirm
      step={search}
      onStepChange={(next) => {
        void navigate({ search: next, replace: true })
      }}
    />
  )
}
